const googletagmanagerId = () => {
	const projectName = process.env.REACT_APP_PROJECT_NAME;
	const domain = window.location.origin;

	const forceApplyInLocalHost = false;
	const isStage = domain.includes('stg');

	// production
	const prod = {
		keepa: 'GTM-NGGWZKFM',
		entekhab: '',
	};

	// staging
	const stg = {
		keepa: 'GTM-NV4DCKXP',
		entekhab: '',
	};

	const matchGoogleManagerIds = forceApplyInLocalHost || isStage ? stg : prod;

	return matchGoogleManagerIds[projectName] || false;
};

export default googletagmanagerId;
